import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { ColorFunction } from '@components/common/CircleBar';
import { font } from '@styles/fonts';
import { WALLBOARD_TILE_LAYOUT } from '@components/wallboard/constants';

export const getOEEColor = (value: number, C: ColorFunction): string => {
  if (value < 40) return C('Wallboard/Light/Gauge OEE Poor');
  if (value < 60) return C('Wallboard/Light/Gauge OEE Fair');
  if (value < 75) return C('Wallboard/Light/Gauge OEE Good');
  if (value < 85) return C('Wallboard/Light/Gauge OEE Excellent');
  return C('Wallboard/Light/Gauge OEE World Class');
};

export const getNCFileFontConfig = (tileHeight: number) => {
  const ncFileAreaHeight = tileHeight * WALLBOARD_TILE_LAYOUT.NC_FILE_AREA_HEIGHT_RATIO;
  const paddingTop = Math.round(ncFileAreaHeight * WALLBOARD_TILE_LAYOUT.NC_FILE_PADDING_TOP_RATIO);
  const lineHeight = Math.round((ncFileAreaHeight - paddingTop) / WALLBOARD_TILE_LAYOUT.NC_FILE_VISIBLE_LINES);
  const fontSize = Math.round(lineHeight / WALLBOARD_TILE_LAYOUT.NC_FILE_LINE_HEIGHT_TO_FONT_SIZE_RATIO);
  const letterSpacing = Math.round(fontSize * WALLBOARD_TILE_LAYOUT.NC_FILE_LETTER_SPACING_RATIO * 100) / 100;

  return {
    fontFamily: font['Mono Body'].fontFamily,
    fontWeight: font['Mono Body'].fontWeight,
    fontSize,
    lineHeight,
    letterSpacing,
  };
};

export const getPlaceholderFontSize = (text: string, scale: ScaleFunction): number => {
  if (text.length <= 25) return scale(11);
  if (text.length <= 35) return scale(9);
  return scale(8);
};

export const getPiecesFontSize = (
  quantityReady: number,
  quantityTarget: number | null,
  showFraction: boolean,
  scale: ScaleFunction,
): number => {
  const readyLen = String(Math.min(quantityReady, 99999)).length;

  if (showFraction) {
    const targetLen = quantityTarget != null ? String(Math.min(quantityTarget, 99999)).length : 0;
    const digitCount = Math.max(readyLen, targetLen);
    if (digitCount <= 1) return scale(13);
    return scale(11);
  }

  if (readyLen <= 3) return scale(13);
  if (readyLen <= 4) return scale(12);
  return scale(10);
};
